import request from '@/utils/request';


export function changePass(data) {
    return request({
        url: '/user/changePass',
        method: 'post',
        data
    })
}

//获取个人信息
export function selfCenter() {
    return request({
        url: '/user/selfCenter',
        method: 'get',
    })
}

//获取cas登陆后的用户对象
export function getTicket(params) {
    return request({
      url: '/user/getTicket',
      method: 'get',
      params,
    });
  }
  